import { Tag } from "@blueprintjs/core";

export const TokenList = ({
  items,
  onRemove,
}: {
  items: string[];
  onRemove: (index: number) => void;
}) => (
  <div className="mt-3 flex min-h-9 flex-wrap items-center gap-2">
    {items.length === 0 && (
      <span className="text-sm font-semibold text-slate-400">-</span>
    )}

    {items.map((item, index) => (
      <Tag
        className="!bg-slate-100 !px-2.5 !py-1 !text-slate-700"
        interactive={false}
        key={`${item}-${index}`}
        large
        onRemove={() => onRemove(index)}
      >
        {item}
      </Tag>
    ))}
  </div>
);
